import * as React from 'react';

import { IConditionalFreeDelivery } from '../model';

import { Link } from './styled';

export function transformToMessageValues(
  targets: IConditionalFreeDelivery['targets']
) {
  return targets.reduce((acc, target, idx) => {
    const type = target.type.toLowerCase();
    const order = idx + 1;
    return {
      ...acc,
      [`${type}${order}`]: (
        <Link key={target.url} href={target.url}>
          {target.name}
        </Link>
      ),
    };
  }, {});
}
